
import { Vue, Component, Prop } from 'vue-property-decorator';
import { IModal, ModalState } from '@/core/modals/ModalState';

@Component
export default class Modal extends Vue {
    @Prop({ type: Object, required: true })
    protected modal!: IModal;

    protected closeOverlay(data?: any) {
        ModalState.hideModal(this.modal.id, data);
    }
}
